import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

const KpiCards = ({
  loading,
  kpiCards,
  selectedKpiSlots,
  showDefaultSections,
  configLoaded,
  widgetSetting,
  kpiVisibility,
  kpiDensityClass,
  previewKpiGridClass,
  kpiGridClass,
}) => {
  const hasCustomSlots = selectedKpiSlots.filter(Boolean).length > 0;

  // Show skeleton cards during initial loading before config is loaded
  if (loading && !configLoaded) {
    return (
      <div className={`grid ${kpiGridClass} gap-4`}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className={`bg-white rounded-xl ${kpiDensityClass} shadow-sm border border-gray-100`}>
            <div className="flex items-center justify-between mb-3">
              <div className="h-3 w-20 bg-gray-100 rounded animate-pulse" />
              <div className="h-8 w-8 bg-gray-100 rounded-lg animate-pulse" />
            </div>
            <div className="h-7 w-16 bg-gray-100 rounded animate-pulse" />
            <div className="h-3 w-24 bg-gray-100 rounded animate-pulse mt-2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grid ${hasCustomSlots ? previewKpiGridClass : kpiGridClass} gap-4`}>
      {hasCustomSlots ? (
        // Render saved KPI slots
        selectedKpiSlots.map((kpiId, slotIndex) => {
          if (!kpiId) return null;
          const kpi = kpiCards.find((k) => k.id === kpiId);
          if (!kpi) return null;
          return (
            <KpiCard
              key={slotIndex}
              kpi={kpi}
              loading={loading}
              widgetSetting={widgetSetting}
              kpiDensityClass={kpiDensityClass}
            />
          );
        })
      ) : showDefaultSections ? (
        // Fallback to old rendering if no slots selected and config is loaded
        kpiCards.filter((kpi) => kpiVisibility[kpi.id] !== false).map((kpi) => (
          <KpiCard
            key={kpi.label}
            kpi={kpi}
            loading={loading}
            widgetSetting={widgetSetting}
            kpiDensityClass={kpiDensityClass}
          />
        ))
      ) : null}
    </div>
  );
};

const KpiCard = ({ kpi, loading, widgetSetting, kpiDensityClass }) => {
  return (
    <div className={`bg-white rounded-xl ${kpiDensityClass} shadow-sm border border-gray-100 hover:shadow-md transition-shadow`}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs text-gray-400 font-medium">{kpi.label}</span>
        {widgetSetting("kpis", "showIcons", true) && (
          <div
            className="p-2 rounded-lg"
            style={{
              color: "var(--app-icon-color)",
              background: "color-mix(in srgb, var(--app-icon-color) 12%, white)",
            }}
          >
            {kpi.icon}
          </div>
        )}
      </div>
      <div className="text-2xl font-bold text-gray-800">
        {loading ? <div className="h-7 w-12 bg-gray-100 rounded animate-pulse" /> : (kpi.value ?? "—")}
      </div>
      <div className="flex items-center gap-1 mt-1.5 text-xs">
        {loading ? (
          <div className="h-3 w-20 bg-gray-100 rounded animate-pulse" />
        ) : (
          <>
            {widgetSetting("kpis", "showTrends", true) && kpi.trend?.value && (
              <span className={`font-semibold ${kpi.trend.up ? "text-emerald-500" : "text-rose-500"}`}>
                {kpi.trend.up ? <FaArrowUp size={9} className="inline mr-0.5" /> : <FaArrowDown size={9} className="inline mr-0.5" />}
                {kpi.trend.value}
              </span>
            )}
            <span className="text-gray-400">{kpi.trend?.label || "last 30 days"}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default KpiCards;
